import { Head, Link, useForm } from '@inertiajs/react'
import type { FormEvent } from 'react'

export default function Login() {
  const form = useForm({ email: '', password: '', remember_me: true })

  const submit = (e: FormEvent) => {
    e.preventDefault()
    form.post('/login')
  }

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <Head title="登录" />
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">登录账户</h2>
          <p className="mt-2 text-center text-sm text-gray-600">开始使用番茄工作法提高效率</p>
        </div>

        {form.errors.email && (
          <div className="rounded-md bg-red-50 p-4">
            <div className="text-sm text-red-700">{form.errors.email}</div>
          </div>
        )}

        <form className="mt-8 space-y-6" onSubmit={submit}>
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="email" className="sr-only">邮箱</label>
              <input
                id="email"
                type="email"
                autoComplete="email"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                placeholder="邮箱"
                value={form.data.email}
                onChange={(e) => form.setData('email', e.target.value)}
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">密码</label>
              <input
                id="password"
                type="password"
                autoComplete="current-password"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                placeholder="密码"
                value={form.data.password}
                onChange={(e) => form.setData('password', e.target.value)}
              />
            </div>
          </div>

          <div className="flex items-center">
            <input
              id="remember-me"
              type="checkbox"
              checked={form.data.remember_me}
              onChange={(e) => form.setData('remember_me', e.target.checked)}
              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
            />
            <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900">
              30天内免登录
            </label>
          </div>

          <button
            type="submit"
            disabled={form.processing}
            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50"
          >
            {form.processing ? '登录中...' : '登录'}
          </button>

          <div className="text-sm text-center">
            <span className="text-gray-500">还没有账户? </span>
            <Link href="/register" className="font-medium text-blue-600 hover:text-blue-500">
              注册账户
            </Link>
          </div>
        </form>
      </div>
    </div>
  )
}
